<template>
  <span @click="openDialog" v-bind="$attrs">
    <slot>
      <jw-button :title="$t('列选择')">
        <template #icon>
          <icon-storage />
        </template>
        {{ $t('列选择') }}
      </jw-button>
    </slot>
  </span>
  <div class="comp-xl-col-select" v-if="popupDialog">
    <jw-modal titleAlign="start" :title="$t('列选择')" class="dialog-pop" :mask-closable="false" v-model:visible="popupDialog" @ok="handleOk" width="800px" :unmount-on-close="true">
      <jw-row :gutter="12">
        <jw-col :span="13">
          <!-- {{ defStatus }} -->
          <jw-card size="small" class="xl-col-card" :body-style="{ padding: 0 }" :title="$t('可选择的列')">
            <template v-if="colsList && colsList.length > 1">
              <jw-tabs position="left" type="capsule">
                <jw-tab-pane v-for="(item, index) in colsList" :key="index" :title="item.name">
                  <jw-scrollbar style="height: 450px; overflow: auto">
                    <jw-space class="xl-col-item" direction="vertical">
                      <!-- {{item.list}} -->
                      <jw-checkbox @change="ckbChange" v-model="it.colShow" v-for="it in item.list" :key="it.colKey" :value="it.colKey">{{ it.fieldName }}</jw-checkbox>
                    </jw-space>
                  </jw-scrollbar>
                </jw-tab-pane>
              </jw-tabs>
            </template>
            <template v-else>
              <jw-scrollbar style="height: 450px; overflow: auto">
                <div class="xl-col-single">
                  <div class="xl-col-single-item" v-for="it in colsList?.[0]?.list" :key="it.colKey">
                    <jw-checkbox v-model="it.colShow" :value="it.colKey">{{ it.fieldName }}</jw-checkbox>
                  </div>
                </div>
              </jw-scrollbar>
            </template>
          </jw-card>
        </jw-col>
        <jw-col :span="11">
          <jw-card size="small" class="xl-col-card" :body-style="{ padding: 0 }" :title="$t('已添加的列')">
            <template #extra>
              <!-- {{ defFixedLeft.filter((el) => el.colShow).length }}
              {{ defAllColsNoLeft.filter((el) => el.colShow).length }} -->
              <jw-link @click="clearAll">{{ $t('恢复默认') }}</jw-link>
            </template>
            <jw-scrollbar style="height: 450px; overflow: auto">
              <div class="xl-col-selected">
                <div class="xl-col-selected-fixed">
                  <div class="xl-col-selected-cols-item drag-placeholder">{{ $t('拖到这里') }}</div>
                  <draggable class="list-group fixed-group" :scroll="true" animation="300" :move="onMove" @add="dragAdd($event, 1)" @end="dragEnd($event, 1)" :list="defFixedLeft" group="cols" itemKey="colKey" :sort="true">
                    <template #item="{ element, index }">
                      <div class="xl-col-selected-cols-item" v-if="element.colShow">
                        <icon-drag-dot-vertical class="xl-col-selected-cols-item-icon" />
                        <div class="xl-col-selected-cols-item-title">{{ element.fieldName }}</div>
                        <icon-close class="xl-col-selected-cols-item-del" @click="delItem({ element, index }, 1)" />
                      </div>
                    </template>
                  </draggable>
                </div>
                <div class="jw-divider-wrap">
                  <jw-divider class="xl-divider" orientation="center">{{ $t('以上指标将横向固定') }}</jw-divider>
                </div>
                <div class="xl-col-selected-cols">
                  <div class="xl-col-selected-cols-item drag-placeholder">{{ $t('拖到这里') }}</div>
                  <draggable class="list-group" :scroll="true" animation="300" :move="onMove" @add="dragAdd($event, 2)" @end="dragEnd($event, 2)" :list="defAllColsNoLeft" group="cols" itemKey="colKey" :sort="true">
                    <template #item="{ element, index }">
                      <div class="xl-col-selected-cols-item" v-if="element.colShow">
                        <icon-drag-dot-vertical class="xl-col-selected-cols-item-icon" />
                        <div class="xl-col-selected-cols-item-title">{{ element.fieldName }}</div>
                        <icon-close class="xl-col-selected-cols-item-del" @click="delItem({ element, index }, 2)" />
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </jw-scrollbar>
          </jw-card>
        </jw-col>
      </jw-row>
    </jw-modal>
  </div>
</template>

<script setup>
import { ref, computed, watchEffect } from 'vue';
import draggable from 'vuedraggable';
import { useI18n } from 'vue-i18n';
import { watch } from 'vue';
const { t } = useI18n();
const props = defineProps({
  cols: {
    type: Array,
    default() {
      return [];
    }
  },
  defcols: {
    type: Object,
    default() {
      return {};
    }
  }
});
const emits = defineEmits(['cb']);

const columns = ref(props.cols);
const colsBase = computed(() => props.defcols);
const defColumns = ref([]);
const defStatus = ref(false);
// 计算默认值
function setDef(el) {
  const col = props.cols.find((ele) => ele.colKey === el);
  let tmp = {};
  const cur = colsBase.value?.k[el];
  if (col) {
    tmp = { ...col };
  }
  // 固定
  if (cur?.fixed) {
    tmp.fixed = cur.fixed;
  } else {
    delete tmp.fixed;
  }
  // 宽度
  if (cur?.width) {
    tmp.width = cur.width;
  } else {
    delete tmp.width;
  }
  // 展示是否
  if (cur?.colShow === false) {
    tmp.colShow = cur.colShow;
  } else {
    delete tmp.colShow;
  }
  return tmp;
}

// 原始默认值
defColumns.value = colsBase.value?.sort?.map(setDef);

// 获取所有排序的列  colType = '基础字段' || '其他'
const defAllCols = computed(() => props.cols.filter((el) => el.colType !== false));
// 不参与排序的列
const defNoSortCols = computed(() => props.cols.filter((el) => el.colType === false));

// 右侧上
const defFixedLeft = ref(defAllCols.value.filter((el) => el.fixed === 'left'));
// 右侧下
const defAllColsNoLeft = ref(defAllCols.value.filter((el) => !el.fixed));

watchEffect(() => {
  defColumns.value = colsBase.value?.sort?.map(setDef);
});

// 弹窗
const popupDialog = ref(false);
const openDialog = () => {
  popupDialog.value = true;
  // 默认值为false
  defStatus.value = false;

  // 右侧上
  defFixedLeft.value = defAllCols.value.filter((el) => el.fixed === 'left');
  // 右侧下
  defAllColsNoLeft.value = defAllCols.value.filter((el) => !el.fixed);
};
const handleOk = () => {
  let o = newCols.value;
  if (defStatus.value) {
    o = defColumns.value;
  }
  emits('cb', o);
};
// 获取数组左侧
const colsList = computed(() => {
  const c = [];
  columns.value.forEach((el) => {
    if (el.colShow === undefined) {
      el.colShow = true;
    }
    // 循环生成分类
    let xlct = el.colType;
    if (xlct !== false) {
      if (xlct === undefined) {
        xlct = t('其他');
      }
      const i = c.findIndex((ele) => ele.name === xlct);
      if (i === -1) {
        const tmp = {
          name: xlct,
          ckb: [],
          list: [el]
        };
        c.push(tmp);
      } else {
        c[i].list.push(el);
      }
    }
  });
  return c;
});
const newCols = computed(() => {
  const t = [...defFixedLeft.value, ...defAllColsNoLeft.value, ...defNoSortCols.value];
  return t;
});
// checkbox 点击事件
const ckbChange = () => {
  // 恢复为false
  defStatus.value = false;
};

// 设置不显示(删除图标)
const delItem = ({ element, index }, tp) => {
  console.log(element, index, tp);
  if (tp === 1) {
    defFixedLeft.value[index].colShow = false;
  }
  if (tp === 2) {
    defAllColsNoLeft.value[index].colShow = false;
  }
  // 恢复为false
  defStatus.value = false;
};
// 排序事件
const dragAdd = (e, tp) => {
  if (tp === 1) {
    defFixedLeft.value[e.newIndex].fixed = 'left';
  }
  if (tp === 2) {
    const i = defAllColsNoLeft.value.findIndex((el) => el.colShow !== false);
    defAllColsNoLeft.value[i + e.newIndex].fixed = undefined;
    delete defAllColsNoLeft.value[i + e.newIndex].fixed;
  }
};
const onMove = (e) => {
  const targetClass = e.to.getAttribute('class');
  if (targetClass?.split(' ')?.indexOf('fixed-group') != -1 && e.draggedContext.element?.fieldType == 27) {
    // 子表单不允许固定列
    return false;
  }
  return true;
};
const dragEnd = () => {
  // 恢复为false
  defStatus.value = false;
};

// 恢复默认
const clearAll = () => {
  defColumns.value = colsBase.value?.sort?.map(setDef);
  console.log(
    254,
    defColumns.value,
    defColumns.value.map((el) => el.colShow)
  );
  columns.value = defColumns.value; //?.map((el) => ({ ...el }));
  // 右侧上
  defFixedLeft.value = defColumns.value.filter((el) => el.fixed === 'left' && el.colType !== false).map((el) => ({ ...el, colShow: el.colShow === undefined ? true : undefined }));
  // 右侧下
  defAllColsNoLeft.value = defColumns.value.filter((el) => !el.fixed).map((el) => ({ ...el, colShow: el.colShow === undefined ? true : undefined }));
  console.log(304294, defAllCols.value, defFixedLeft.value, defAllColsNoLeft.value);
};

watch(
  () => props.cols,
  () => {
    columns.value = props.cols;
  },
  {
    deep: true
  }
);

// 导出方法
defineExpose({
  openDialog
});
</script>
<style scoped lang="less">
@import './fh-col-select.less';
</style>
